<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc || 'paid_price'"
    :size="size"
    filterable
    clearable
  >
    <el-option v-for="item in inventory" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import inventory from "@/utils/mixins/components/inventory";

export default {
  mixins: [inventory],
  props: ["payment_type_id"],
  mounted() {
    if (this.inventory && this.inventory.length === 0) {
      this.getInventory();
    }
  },
  watch: {
    payment_type_id: {
      handler: function(val, oldVal) {
        this.selected = val;
        this.$emit("input", this.selected);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      inventory: "paymentTypes/inventory"
    })
  },
  methods: {
    ...mapActions({
      getInventory: "paymentTypes/inventory"
    })
  }
};
</script>
